import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { HttpRequestResponse } from '../../../lib/models/http-request-response.model';
import { HttpRequestService } from '../../../lib/services/http-request.service';
import { MenuPortaleComponent } from '../components/menu-portale.component';
import { SectionTitleComponent } from '../components/section-title.component';
import { EvCodiceFiscaleComponent } from '../../../lib/components/ev-codice-fiscale.component';
import { MatCheckbox } from '@angular/material/checkbox';
import { RouterLink } from '@angular/router';
import { MatButton } from '@angular/material/button';
import { ScaricaAppComponent } from '../components/scarica-app.component';
import { PortaleLayoutFooterComponent } from '../../layout/portale-layout-footer/portale-layout-footer.component';

@Component({
    selector: 'app-accesso-video-call',
    templateUrl: './accesso-video-call.component.html',
    styleUrls: ['../../../lib/themes/portale.theme.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MenuPortaleComponent, SectionTitleComponent, ReactiveFormsModule, EvCodiceFiscaleComponent, MatCheckbox, RouterLink, MatButton, ScaricaAppComponent, PortaleLayoutFooterComponent]
})
export class AccessoVideoCallComponent {
  private httpRequestService = inject(HttpRequestService);

  errorMessage: string;

  form = new FormGroup({
    codiceFiscale: new FormControl('', [Validators.required]),
    accepted: new FormControl(false, [Validators.requiredTrue])
  })

  verificaVideoCall() {
    this.httpRequestService.post('/auth/accesso-light/', {
      codiceFiscale: this.form.controls.codiceFiscale.value.toUpperCase(),
    }).subscribe((response) => {
      if (HttpRequestResponse.isSuccessResponse(response)) {
        if (response.data?.attivo == 'S') {
          location.href = response.data?.link_videochiamata;
        }
      } else {
        this.errorMessage = response.message;
      }
    });
  }
}
